export default __webpack_public_path__ + "static/media/3.3b2171c4.webp";